// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__162RL","errorLogs":"styles_errorLogs__3s-fV"};